import { render, staticRenderFns } from "./travel-quote-info.vue?vue&type=template&id=bb25f108&scoped=true&"
import script from "./travel-quote-info.vue?vue&type=script&lang=js&"
export * from "./travel-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./travel-quote-info.vue?vue&type=style&index=0&id=bb25f108&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb25f108",
  null
  
)

export default component.exports